import CONSTANTS from 'src/utils/constants';
import { WorksheetStatus } from 'src/models/multidimensional-allocation/MultiAllocationSheetData';
import { DAS_DRAFT_VERSION, DerivedAllocationSheetData } from 'src/models/derived-allocation-sheet/DerivedAllocationSheet';
import { DatasetRecord } from 'src/models/tp-allocation/DatasetRecord';

/** State of the derived allocation sheet builder page. */
export interface DerivedAllocationSheetBuilderState {
    sheet: DerivedAllocationSheetData | null;
    availableVersions: number[];
    loading: boolean;
    error?: string;
    viewMode: string;
    /** Saved Step 1 rows, read by the later steps for formula suggestions. */
    dataSources: DatasetRecord[];
    /** Incremented to refetch the sheet header after a write. */
    sheetRefreshToken: number;
}

export const initialState: DerivedAllocationSheetBuilderState = {
    sheet: null,
    availableVersions: [],
    loading: true,
    viewMode: CONSTANTS.VIEW_MODE.READ_ONLY,
    dataSources: [],
    sheetRefreshToken: 0,
};

export interface DeriveDasViewModeArgs {
    canEdit: boolean;
    status?: WorksheetStatus;
    sheetVersion?: number;
}

/**
 * View mode of the builder. Only the draft version in DRAFT_IN_PROGRESS can be edited, and derived
 * allocation sheets have no edit lock:
 * 1. no edit permission: FROZEN
 * 2. any other status or version: READ_ONLY
 * 3. otherwise EDITABLE
 */
export function deriveDasViewMode(args: DeriveDasViewModeArgs): string {
    const { canEdit, status, sheetVersion } = args;
    if (!canEdit) {
        return CONSTANTS.VIEW_MODE.FROZEN;
    }
    if (status !== 'DRAFT_IN_PROGRESS' || sheetVersion !== DAS_DRAFT_VERSION) {
        return CONSTANTS.VIEW_MODE.READ_ONLY;
    }
    return CONSTANTS.VIEW_MODE.EDITABLE;
}
